import React from "react";

import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import("../../app/styles/founders.css");
import "../../app/styles/about.css";

import AboutIntroSection from "./AboutIntroSection";
import AboutHistorySection from "./AboutHistorySection";
import AboutTimeLineSection from "./AboutTimeLineSection";



import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const AboutPage = ({ user }) => {

    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("about");


    const editable = !!user;


    if (loading) {
        return (
            <div className="container">
                <p>Loading...</p>
            </div>
        );
    }


    if (error) {
        return (
            <div className="container">
                <p>
                    Failed to load founders page.
                </p>
            </div>
        );
    }


    return (
        <>
            <EditableSection
                uniqueId="founders-intro"
                title="A Journey from Engineering to"
                data={get("intro")}
                Display={AboutIntroSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-history"
                title="A Journey from Engineering to"
                data={get("history")}
                Display={AboutHistorySection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-timeline"
                title="A Journey from Engineering to"
                data={get("timeline")}
                Display={AboutTimeLineSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
        </>
    );
};


export default AboutPage;